import { motion, AnimatePresence } from "framer-motion";
import StateCard from "../sharedUi/stateCard";
import { MdAddShoppingCart, MdPaid } from "react-icons/md";
import { BiCart } from "react-icons/bi";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { BsFillCartCheckFill } from "react-icons/bs";
import { BsCartXFill } from "react-icons/bs";
import { BsCartDashFill } from "react-icons/bs";


export default function OrderCardsUi ({value}) {

    return(<>

        <div>
            <AnimatePresence>  
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="grid grid-cols-1 sm:grid-cols-4 gap-6 py-1 overflow-hidden"
                >
                {[ 
                    {
                        title: "Count Pending Orders",
                        value: value?.count_pending_orders,
                        subtitle: "This Month Analytics",
                        icon: <BsCartDashFill className="text-white" size={18} />,
                        iconBg: "bg-blue-700"
                    },
                    {
                        title: "Count Progress Orders",
                        value: value?.count_in_progress_orders,
                        subtitle: "This Moment Analytics",
                        icon: <BsCartDashFill className="text-white" size={18} />,
                        iconBg: "bg-purple-700"
                    },
                    {
                        title: "Count Complete Orders",
                        value: value?.count_complete_orders?.current_total,
                        percentage: value?.count_complete_orders?.percentage_change,
                        direction : value?.count_complete_orders?.direction,
                        subtitle: "This Moth Analytics",
                        icon: <BsFillCartCheckFill className="text-white" size={18} />,
                        iconBg: "bg-green-700"
                    },
                    {
                        title: "Count Cancelled Orders",
                        value: value?.count_cancelled_orders?.current_total,
                        percentage: value?.count_cancelled_orders?.percentage_change,
                        direction : value?.count_cancelled_orders?.direction,
                        subtitle: "This Moth Analytics",
                        icon: <BsCartXFill className="text-white" size={18} />,
                        iconBg: "bg-red-700"
                    },
                    {
                        title: "Count Orders",
                        value: value?.count_orders,
                        subtitle: "This Month Analytics",
                        icon: <BiCart className="text-white" size={18} />,
                        iconBg: "bg-purple-700"
                    },
                    {
                    title: "New Orders",
                    value: value?.new_orders?.current_total,
                    percentage: value?.new_orders?.percentage_change,
                    direction : value?.new_orders?.direction,
                    subtitle: "This Month Analytics",
                    icon: <MdAddShoppingCart className="text-white" size={18} />,
                    iconBg: "bg-green-700"
                    },
                    {
                        title: "Profit",
                        value: value?.profit,
                        subtitle: "This Month Analytics",
                        icon: <MdPaid className="text-white" size={18} />,
                        iconBg: "bg-green-700"
                    },
                ].map((card, idx) => (
                    <motion.div
                    key={idx}
                    initial={{ rotateY: 90, opacity: 0 }}
                    animate={{ rotateY: 0, opacity: 1 }}
                    exit={{ rotateY: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                    className="w-full"
                    style={{ transformStyle: "preserve-3d" }}
                    >
                    <StateCard {...card} />
                    </motion.div>
                ))}
                </motion.div>
            </AnimatePresence>
        </div>
    
    </>);
};